import React from 'react';

const Dashboard = () => {
  return (
    <div style={{
      minHeight: 'calc(100vh - 64px)',
      width: '100%',
      backgroundImage: `url('/Background.jpeg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      margin: 0,
      padding: 0,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    }}>
    </div>
  );
};

export default Dashboard;